import PaymentHistorySvg from '@assets/images/svg/payment_history.svg';
import React from 'react';
import { View } from 'react-native';

export interface PaymentHistoryIconProps {
    size?: number;
    color?: string;
}

export const PaymentHistoryIcon = React.memo<PaymentHistoryIconProps>(function PaymentHistoryIcon({
    size = 22,
    color = '#4CAF50',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <PaymentHistorySvg width={size} height={size} color={color} />
        </View>
    );
});

export default PaymentHistoryIcon;

